const config = {
  api: {
    host: 'https://api-nonlive.everysign.com/main',
  },
};

export default config;
